import { observer } from "mobx-react-lite";
import React, {useContext, useEffect, useMemo, useState} from "react";
import { RadioUI } from "../../../components/UI/RadioUI/ RadioUI";
import { getPaymentMethodsById } from "../../../http/basketApi";
import { Context } from "../../../index";
import { pushGoogleAnalyticProductAction } from "../../../utils/googleAnalytic";
import { paymentIconsMap } from "./paymentIcons";
import "./paymentMethods.scss";

const PaymentMethods = observer((props) => {
  const { basket, delivery } = useContext(Context);
  const [allPaymentsType, setAllPaymentsType] = useState(null);
  const [avPaymentsType, setAvPaymentsType] = useState(null);

  useEffect(() => {
    if (delivery.active?.payment_type) {
      getPaymentMethodsById(delivery.active.payment_type, basket.hasGift).then(
        (response) => {
          if (response.error) {
            return false;
          }
          const result = response.reduce((acc, item) => {
            if (item.code === 'sbp') {
                return [item, ...acc];
            }
            return [...acc, item];
          }, []);
          

          setAllPaymentsType(result);
          setAvPaymentsType(result.filter((el) => el.code != 'sertificate'))
        }
      );
    }

    basket.setSelectPaymentTypeError("");
  }, [delivery.active]);

  const selectPaymentTypeHandler = (item) => {
    if (basket.basketItems && basket.basketItems.length) {
      const googleAnalyticBasketItems = basket.basketItems.map(
        (basketItem) => ({
          ...basketItem.item,
          currentSize: basketItem.currentSize,
          customProps: { quantity: basketItem.count },
        })
      );
      pushGoogleAnalyticProductAction(
        "add_payment_info",
        googleAnalyticBasketItems,
        { payment_type: item.name }
      );
    }
    basket.setSelectPaymentType(item);
    basket.setSelectPaymentTypeError("");
  };

    useEffect(() => {
        if(basket.certificateTotal > 0){
            let sertificatePayment = allPaymentsType?.filter((el) => el.code == 'sertificate')
            if(sertificatePayment?.length > 0){
                selectPaymentTypeHandler(sertificatePayment[0])
            }
        }

    }, [basket.certificateTotal, allPaymentsType])

  return (
    <div className={"paymentMethods"}>
      {avPaymentsType?.map((el) => (
          <>
            <div
              key={el.id}
              onClick={() => selectPaymentTypeHandler(el)}
              className={"paymentMethods__item"}
            >
              <RadioUI
                name="example"
                value="option1"
                checked={
                  basket.selectPaymentType?.id === el.id
                }
              />
              <span className={"paymentMethods__text"}>{el.name}</span>
              <div className={"paymentMethods__icon"}></div>
              {/* {el.code === 'ysplit' && <div className={"ysplit_action"}>Акция! 6 месяцев без переплат!</div>} */}
              {paymentIconsMap[el.code] &&
                React.createElement(paymentIconsMap[el.code])}
                {
                    ((el.code === 'ysplit' || el.code ==='dolyami') && basket.selectPaymentType?.id === el.id) &&
                        <div className={"dop_text_payment"}>
                            <span className={"dop_text_grey"}>Раздели покупку на 4 платежа.
                                Без процентов и переплат. </span>
                            <a href={"/shares/"} target={"_blank"} rel="noreferrer"  className={"dop_text_link"}>Читать подробнее</a>
                            <span className={"dop_text_bold"}> Обратите внимание! </span>
                            <span className={"dop_text_black"}>Подарочные сертификаты и бонусы к оплате не принимаются.</span>
                        </div>
                }
            </div>
          </>
      ))}
        {
            delivery.fitting &&
            <div className={"select_pay_description"}>
                <p>
                    <span> После оплаты заказа, примерка будет не доступна. </span>
                </p>
            </div>
        }
       
    </div>
  );
});

export default PaymentMethods;
